import { render, staticRenderFns } from "./StudentCourseSlidebar.vue?vue&type=template&id=2bcf84bc"
import script from "./StudentCourseSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentCourseSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports